/*
This serves as a way to bind events throughout different pages and creates
such bindings on load.
*/

import $ from 'jquery';
import _ from 'underscore';

import 'jquery_placeholder';

import DropdownView from 'core/views/dropdown';
import CheckboxView from 'core/views/checkbox';
import ExtraMobileLinkView from 'core/views/extra_mobile_link';


_.each($('.form-dropdown'), function (dropdown_el) {
  new DropdownView({ el: dropdown_el });
});
_.each($('.check'), function (checkbox_el) {
  if (!$(checkbox_el).data('checkbox_view')) {
    new CheckboxView({ el: checkbox_el });
  }
});
if (mobile) {
  // If we are in the native app, make sure external links open in a browser
  if (window.localStorage.getItem('API_KEY')) {
    _.each($('a.extra_mobile_link'), function (link_el) {
      new ExtraMobileLinkView({ el: link_el });
    });
    // If the user hasn't logged in yet, disable external links
  } else {
    $('a.extra_mobile_link').click(function (e) {
      e.preventDefault();
    });
  }
  // White label the footer content
  if (COPYRIGHT) {
    var $copyright = $('#copyright');
    $copyright.html(COPYRIGHT);
    _.each($('a', $copyright), function (link_el) {
      new ExtraMobileLinkView({ el: link_el });
    });
  }
  if (LOGO) {
    $('#footer img.logo').attr('src', LOGO);
  }

}
// Enable placeholders in older browsers
$('input, textarea', '.no-placeholder').placeholder();



// WEBPACK FOOTER //
// ./static/js/utils/global_widgets.js